import get from 'lodash/get'

export default (startFieldPath, endFieldPath) => function (value) {
  let startValue = get(this, startFieldPath)
  let endValue = get(this, endFieldPath)

  return startValue <= value && value <= endValue
}



// WEBPACK FOOTER //
// ./src/validators/inParentBounds.js